export default __webpack_public_path__ + "static/media/tony-3.5f6de26a.jpeg";